import React from 'react'
import { Weather } from './component/Weather'

export default function App() {
  return (
    <div>

      <>
        <Weather />
      </>

    </div>
  )
}
